var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 14.875H12.25V4.375H1.75V14.875H4.375",
    stroke: "#219D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 14.875H19.25V11.9525C19.2504 11.4927 19.1601 11.0374 18.9845 10.6125C18.8088 10.1876 18.5512 9.80153 18.2262 9.47625L16.625 7.875H12.25",
    stroke: "#219D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.25 14.875H13.125",
    stroke: "#219D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.5625 17.5C7.77062 17.5 8.75 16.5206 8.75 15.3125C8.75 14.1044 7.77062 13.125 6.5625 13.125C5.35438 13.125 4.375 14.1044 4.375 15.3125C4.375 16.5206 5.35438 17.5 6.5625 17.5Z",
    stroke: "#219D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3125 17.5C16.5206 17.5 17.5 16.5206 17.5 15.3125C17.5 14.1044 16.5206 13.125 15.3125 13.125C14.1044 13.125 13.125 14.1044 13.125 15.3125C13.125 16.5206 14.1044 17.5 15.3125 17.5Z",
    stroke: "#219D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.bf52d5a77e9b0beb3bbfbc198e326d9c.svg";
export { ForwardRef as ReactComponent };